import _ from 'lodash';
import { ROLES } from '../constants';

export const getAdvisorConvertedRole = (role: string) => {
  if (role === ROLES.ADVISOR) {
    return 'Standard advisor';
  }
  return _.capitalize(role.replace(/_/g, ' '));
};

export function getCookie(cname: string) {
  const name = `${cname}=`;
  // eslint-disable-next-line no-undef
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
